
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.285 18.6c-.26 0-.51-.099-.71-.288l-7.979-7.945a.988.988 0 010-1.403.999.999 0 011.41 0l7.269 7.238 7.289-7.258a.999.999 0 011.41 0 .989.989 0 010 1.404l-8 7.964a.963.963 0 01-.69.289z"}})])
          )
        }
      }
    